// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2137":"86f886db","2680":"86f886db","5026":"5ca5f6f9","8175":"409c6082","8956":"431ad528","8957":"4a3826af","9982":"4a0e52ef"}[chunkId] + ".chunk.css";
};